import { parseISO, differenceInHours, differenceInMinutes, differenceInSeconds } from 'date-fns';

export function isOlderThanOneHour(dateInfo) {
  if (!dateInfo) return true

  const createdDate = parseISO(dateInfo);
  const hoursDiff = differenceInHours(new Date(), createdDate);
  return hoursDiff > 1;
}

export function isOlderThan30Minutes(dateInfo) {
  if (!dateInfo) return true

  const createdDate = parseISO(dateInfo);
  const minutesDiff = differenceInMinutes(new Date(), createdDate);
  return minutesDiff > 30;
}

export function isOlderThanFiveMinutes(dateInfo) {
  if (!dateInfo) return true

  const createdDate = parseISO(dateInfo);
  const minutesDiff = differenceInMinutes(new Date(), createdDate);
  return minutesDiff > 5;
}

export function isOlderThan10Seconds(dateInfo) {
  if (!dateInfo) return true

  const createdDate = parseISO(dateInfo);
  const secondsDiff = differenceInSeconds(new Date(), createdDate);
  return secondsDiff > 10;
}
